import StorageFolderList from './StorageFolderList/StorageFolderList';

export interface IAsset {
  id: number;
  name: string;
  folder_count: number
}

export interface IStorageProps {
  assets: IAsset[];
  refetchAssets: () => void;
}

const Storage = ({
  assets,
  refetchAssets,
}: IStorageProps) => {
  return (
    <StorageFolderList
      assets={assets}
      refetchAssets={refetchAssets}
    />
  );
};

export default Storage;
